import React, { useEffect, useState } from 'react';
import { AutoComplete } from 'material-ui';
import styles from 'styles';
import _ from 'lodash';
import { checkIfUpdate } from 'components/Cargoes/Assigners/utils';

/**
 * 
 * @param {Props} props 
 */
export default function CargoCategoryAutoComplete({
    cargoTypes, 
    saveStatusCargoAssigner,
    underlineDisabledStyle = {},
    disabled,
    ...props
}) {
    const _cargoCategoryNames = cargoTypes.map(item => ({
        name: item.name,
        item,
    }));

    const [item, setItem] = useState(props.item);
    const [cargoCategoryNames] = useState(_cargoCategoryNames);

    useEffect(() => {
        setItem(props.item);
    }, [props.item]);

    const onUpdateInputCargoType = (searchText) => {
        const _item = _.cloneDeep(item);
        _item.parent.red.name = searchText;

        _item.isUpdate = checkIfUpdate(item, cargoTypes);

        props.updateItem(_item);

        saveStatusCargoAssigner && saveStatusCargoAssigner(_item);
    };

    const onNewRequestCargoTypes = (updateProperties) => {
        if (!updateProperties.name) {
            return;
        }

        const _item = _.cloneDeep(item);

        _item.isUpdate = false;

        _item.parent.red.name = updateProperties.name;
        _item.parent.red._id = updateProperties.item._id;
        _item.details = updateProperties.item.details;

        if (_item.name &&
            _item.name.length >= 3
        ) {
            _item.isUpdate = true;
        }

        props.updateItem(_item);

        saveStatusCargoAssigner && saveStatusCargoAssigner(_item);
    };

    return (
        <AutoComplete
            textFieldStyle={styles.autoCompleteCSS}
            hintText='Cargo type'
            floatingLabelText='Cargo type'
            searchText={item && item.parent ? item.parent.red.name : ''}
            dataSource={cargoCategoryNames}
            dataSourceConfig={{ text: 'name', value: 'item' }}
            onUpdateInput={onUpdateInputCargoType}
            onNewRequest={onNewRequestCargoTypes}
            filter={AutoComplete.caseInsensitiveFilter}
            listStyle={styles.autoCompleteListStyle}
            inputStyle={{ fontSize: '16px' }}
            popoverProps={{
                canAutoPosition: true,
            }}
            disabled={!!disabled}
            underlineDisabledStyle={{ ...underlineDisabledStyle }}
        />
    );
}

/**
 * props
 * @typedef {Object} Props
 * @property {import('../Cargoes/Assigners/UpdateRealCargoDialog').RealCargo} item
 * @property {any} cargoTypes
 * @property {any} [underlineDisabledStyle]
 * @property {Function} [saveStatusCargoAssigner]
 * @property {boolean} [disabled]
 * @property {Function} updateItem
 */



// WEBPACK FOOTER //
// ./app/components/common/CargoCategoryAutoComplete.jsx